<template>
  <el-carousel
    v-if="images && images.length"
    trigger="click"
    indicator-position="outside"
    class="text-center"
  >
    <el-carousel-item v-for="(image, index) in images" :key="index">
      <a :href="image.url" target="_blank">
        <img :src="image.url" :alt="image.name" height="300px"/>
      </a>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: 'app-image-carousel',

  props: {
    images: Array,
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/shared/file/image-carousel.vue?12cf205e